import React from 'react';
import type { MenuItem } from '../../../types';
import styles from '../DesktopNavigation.module.scss';

interface NestedDropdownItemProps {
  item: MenuItem;
  onItemClick: (item: MenuItem) => void;
}

export const NestedDropdownItem = ({ item, onItemClick }: NestedDropdownItemProps) => {
  const testId = `${item.id}MenuDropdownOption`;
  
  return (
    <li>
      <button 
        onClick={() => onItemClick(item)}
        className={styles.nestedItem}
        data-testid={testId}
      >
        {item.label}
      </button>
    </li>
  );
}; 